__turbopack_context__.v({
  "additionalText": "GlobalToast-module__8lAU4W__additionalText",
  "imageContainer": "GlobalToast-module__8lAU4W__imageContainer",
  "mainText": "GlobalToast-module__8lAU4W__mainText",
  "notificationBox": "GlobalToast-module__8lAU4W__notificationBox",
  "textContainer": "GlobalToast-module__8lAU4W__textContainer",
  "toast": "GlobalToast-module__8lAU4W__toast",
  "toastContainer": "GlobalToast-module__8lAU4W__toastContainer",
  "toastError": "GlobalToast-module__8lAU4W__toastError",
  "toastSuccess": "GlobalToast-module__8lAU4W__toastSuccess",
});
